import React from "react";

const CashFuseCard = ({ shopName, offerAmount, ctaText, backgroundImage, offerName }) => {
  return (
    <div
      className="bg-cover rounded-lg p-6 text-white font-sans relative w-full h-full flex flex-col justify-between"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Shop Name - Positioned top right */}
      <div className="absolute top-3 right-3 text-xs font-bold bg-purple-800 bg-opacity-50 p-1 rounded">{shopName}</div>

      <div className="flex items-center justify-between">
        <div className="ps-3">
          {/* Flat Text */}
          <div className="text-sm font-bold">FLAT</div>

          {/* Offer Amount */}
          <div className="text-6xl font-bold">{offerAmount}</div>

          {/* Offer Text */}
          <div className="text-lg mb-4">Cashfuse Off</div>
        </div>

        {/* Amount Text */}
        <div
          className="bg-white text-black px-3 py-2 rounded text-md text-center inline-block relative right-[10%] xl:right-[30%]   max-w-[120px] leading-tight"
          dangerouslySetInnerHTML={{ __html: offerName }}
        />
      </div>

      {/* CTA Button */}
      <button className="bg-orange-600 text-white px-6 py-2 rounded-full text-sm hover:bg-orange-500 absolute bottom-3 right-3">
        Shop Now
      </button>
    </div>
  );
};

export default CashFuseCard;
